import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import DocumentContent from '../components/Document/DocumentContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../redux/language/selector'



const Document = () => {

  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('document.title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <DocumentContent/>
        
    </>
  )
}

export default Document